module.exports = __webpack_public_path__ + "img/4.010b2704.jpg";